(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash", "reactDOM"], factory);
	else if(typeof exports === 'object')
		exports["cartEditorMode"] = factory(require("react"), require("lodash"), require("react-dom"));
	else
		root["cartEditorMode"] = factory(root["React"], root["_"], root["ReactDOM"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__30__) {
return 